import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone } from "lucide-react";

export default function Announcements() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/announcements?platform=web").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="announcements" data-testid="announcements-section" className="py-20 lg:py-24 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-10 max-w-3xl">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#5C6661] mb-4">
            <Megaphone className="w-4 h-4 text-[#D4A373]" />Announcements
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1C201E]">What&rsquo;s Happening</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.slice(0, 6).map((a, i) => (
            <div key={a.id} data-testid={`announcement-${i}`} className="p-6 bg-white border border-[#E5E0D8] rounded-2xl">
              <div className="text-xs uppercase tracking-[0.15em] text-[#5C6661]">{new Date(a.date).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" })}</div>
              <h3 className="mt-2 font-serif-display text-xl text-[#1C201E]">{a.title}</h3>
              <p className="mt-2 text-sm text-[#5C6661] whitespace-pre-line">{a.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
